import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../../@core/services/account.service';

@Component({
  selector: 'dpay-registration.completed.component',
  styleUrls: ['./registration.completed.component.scss'],
  templateUrl: './registration.completed.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistrationCompletedComponent {
  email: string;

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};

  constructor(protected service: AccountService,
    protected cd: ChangeDetectorRef,
    route: ActivatedRoute,) {
    route.params.subscribe(params => {
      this.email = params.email
    });
  }
}
